// extracted by mini-css-extract-plugin
export default {"container":"container-C6tLa","title":"title-YxtGW"};